import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-reservation',
  imports: [ReactiveFormsModule],
  templateUrl: './reservation.html',
  styleUrl: './reservation.scss',
})
export class Reservation {
  private readonly fb = inject(FormBuilder);

  submitted = signal(false);
  reservationForm: FormGroup;

  readonly timeSlots = [
    '8:00', '8:30', '9:00', '9:30', '10:00', '10:30',
    '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
    '17:00', '17:30',
  ];

  readonly seatingOptions = [
    { value: 'indoor', label: 'Beltér' },
    { value: 'terrace', label: 'Terasz' },
  ];

  constructor() {
    const today = new Date().toISOString().split('T')[0];

    this.reservationForm = this.fb.group({
      date: [today, Validators.required],
        time: ['12:00', Validators.required],
      seating: ['indoor', Validators.required],
      guests: [2, [Validators.required, Validators.min(1), Validators.max(20)]],
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^[\+]?[0-9\s\-]{7,15}$/)]],
    });
  }

  get f() {
    return this.reservationForm.controls;
  }

  onSubmit() {
    if (this.reservationForm.valid) {
      this.submitted.set(true);
      setTimeout(() => this.submitted.set(false), 5000);
      this.reservationForm.reset({
        date: new Date().toISOString().split('T')[0],
        time: '12:00',
        seating: 'indoor',
        guests: 2,
      });
    } else {
      this.reservationForm.markAllAsTouched();
    }
  }
}
